import { CustomComponentProps } from "utils/types/generalTypes";
import SVG from "../core/SVG";
import { useState } from "react";
import Switch from "../core/Switch";

export type SettingsTogglerProps = CustomComponentProps & {
    svg: string;
    title: string;
    details?: string;
    defaultCheck?: boolean;
};

const SettingsToggler = ({
    svg,
    title,
    details,
    defaultCheck = false,
    className,
    style
}: SettingsTogglerProps) => {
    const [checked, setChecked] = useState(defaultCheck);
    return (
        <div
            className={`settings-item d-flex flex-j-start w-full flex-a-center gap-10 pt-20 pl-10 pr-10 w-full ${className}`}
            style={style}
        >
            <SVG svg={svg} size={24} style={{ minWidth: "25px" }} />
            <div className="settings-item-text d-flex flex-j-center flex-a-start flex-col gap-5">
                <span className="settings-h2 fw-500 black-text white-text">
                    {title}
                </span>
                {details ? (
                    <span className="settings-detail momeento-p grey-text">
                        {details}
                    </span>
                ) : (
                    ""
                )}
            </div>
            <Switch
                checked={checked}
                handleClick={() => setChecked(() => !checked)}
                className="ml-auto"
            />
        </div>
    );
};

export default SettingsToggler;
